import { ComponentProps, FC, PropsWithChildren, forwardRef } from 'react';
import { CatModal } from '@blocks-react/components/Modal';

export const Modal: FC<PropsWithChildren<ComponentProps<typeof CatModal>>> =
  forwardRef(({ children, ...modalProps }, ref) => {
    return (
      <CatModal ref={ref} {...modalProps}>
        {children}
      </CatModal>
    );
  });
